import React, { useEffect } from "react";
import registrationImage from '../../images/banner/banner-account2.jpg';

import { Link } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { VendorRegistration, getAllVendorEmailandUserName, SendOTPforVendorRegistration } from '../../APIs/VendorLoginAPI';
import { handleKeyPress } from "../../APIs/Helper";





export default function Register() {

  const { enqueueSnackbar } = useSnackbar();

  const [UserName, setUserName] = React.useState('');
  const [Email, setEmail] = React.useState('');
  const [Mobile, setMobile] = React.useState('');
  const [Password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [existingUsers, setExistingUsers] = React.useState([]);

  const [otpflag, setOtpFlag] = React.useState(false);

  const [OTP, setOTP] = React.useState('');
  const [generateoTP, setGenerateoTP] = React.useState('');




  const generateRandomOTP = () => {
    const otp = Math.floor(1000 + Math.random() * 9000).toString();
    setGenerateoTP(otp);
    return otp;
  };

  const sendOTP = async () => {
    if (!validateForm()) {
      return;
    }

    const otp = generateRandomOTP();
    const response = await SendOTPforVendorRegistration(Email, Mobile, otp);
    debugger
    if (response.success) {
      setOtpFlag(true);
      enqueueSnackbar('OTP sent successfully', { variant: 'success' });
      return true;
    }

    enqueueSnackbar(response.message || 'Unable to send OTP', { variant: 'error' });
    return false;
  };


  const validateForm = () => {

    if (!UserName.trim()) {
      enqueueSnackbar('Username is required', { variant: 'error' });
      return false;
    }
    if (UserName.length < 4) {
      enqueueSnackbar('Username must be at least 4 characters', { variant: 'error' });
      return false;
    }
    if (!Email.trim()) {
      enqueueSnackbar('Email is required', { variant: 'error' });
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(Email)) {
      enqueueSnackbar('Please enter valid email', { variant: 'error' });
      return false;
    }
    if (!Password) {
      enqueueSnackbar('Password is required', { variant: 'error' });
      return false;
    }
    if (Password.length < 6) {
      enqueueSnackbar('Password must be at least 6 characters', { variant: 'error' });
      return false;
    }
    if (!confirmPassword) {
      enqueueSnackbar('Confirm Password is required', { variant: 'error' });
      return false;
    }
    if (confirmPassword.length < 6) {
      enqueueSnackbar('Confirm Password must be at least 6 characters', { variant: 'error' });
      return false;
    }
    if (Password !== confirmPassword) {
      enqueueSnackbar('Passwords do not match', { variant: 'error' });
      return false;
    }
    return true;
  };

  const handleRegister = async () => {

    if (!validateForm())
      return;

    if (!otpflag) {
      await sendOTP();
      return;
    }

    if (OTP !== generateoTP) {
      enqueueSnackbar('Invalid OTP', { variant: 'error' });
      return;
    }



    try {
      const booleanResult = await VendorRegistration({
        UserName: UserName,
        Password: Password,
        Email: Email,
        Mobile: Mobile,
        Remarks: 'Registered via web'
      });

      if (booleanResult) {
        enqueueSnackbar('Vendor registered successfully!', { variant: 'success' });
        ClearUseState();

        setTimeout(() => {
          window.location.reload();
        }, 3000);

      } else {
        enqueueSnackbar('Registration failed', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Network error. Please try again.', { variant: 'error' });
      console.error(error);
    } finally {
      //setLoading(false);
    }
  };

  const ClearUseState = () => {
    setUserName('');
    setEmail('');
    setMobile('');
    setPassword('');
    setConfirmPassword('');
    setOTP('');
    setGenerateoTP('');
    setOtpFlag(false);
  }





  return (
    <div className="modal modal-account fade" id="modalRegister">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="flat-account">
            <div className="banner-account">
              <img
                alt="banner"
                src={registrationImage}
                width={570}
                height={1263}
              />
            </div>
            <form onSubmit={(e) => e.preventDefault()} className="form-account">
              <div className="title-box">
                <h4>Register</h4>
                <span
                  className="close-modal icon-close2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    window.location.reload();
                  }}
                />
              </div>
              {
                !otpflag && (<>
                  <div className="box">
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="name">User name</label>
                      <div className="ip-field">
                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.4869 14.0435C12.9628 13.3497 12.2848 12.787 11.5063 12.3998C10.7277 12.0126 9.86989 11.8115 9.00038 11.8123C8.13086 11.8115 7.27304 12.0126 6.49449 12.3998C5.71594 12.787 5.03793 13.3497 4.51388 14.0435M13.4869 14.0435C14.5095 13.1339 15.2307 11.9349 15.5563 10.6056C15.8818 9.27625 15.7956 7.87934 15.309 6.60014C14.8224 5.32093 13.9584 4.21986 12.8317 3.44295C11.7049 2.66604 10.3686 2.25 9 2.25C7.63137 2.25 6.29508 2.66604 5.16833 3.44295C4.04158 4.21986 3.17762 5.32093 2.69103 6.60014C2.20443 7.87934 2.11819 9.27625 2.44374 10.6056C2.76929 11.9349 3.49125 13.1339 4.51388 14.0435M13.4869 14.0435C12.2524 15.1447 10.6546 15.7521 9.00038 15.7498C7.3459 15.7523 5.74855 15.1448 4.51388 14.0435M11.2504 7.31228C11.2504 7.90902 11.0133 8.48131 10.5914 8.90327C10.1694 9.32523 9.59711 9.56228 9.00038 9.56228C8.40364 9.56228 7.83134 9.32523 7.40939 8.90327C6.98743 8.48131 6.75038 7.90902 6.75038 7.31228C6.75038 6.71554 6.98743 6.14325 7.40939 5.72129C7.83134 5.29933 8.40364 5.06228 9.00038 5.06228C9.59711 5.06228 10.1694 5.29933 10.5914 5.72129C11.0133 6.14325 11.2504 6.71554 11.2504 7.31228Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="User name"
                          value={UserName}
                          maxLength={25}
                          onChange={(e) => setUserName(e.target.value)}
                        />
                      </div>
                    </fieldset>
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="email">Email address</label>
                      <div className="ip-field">
                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.3125 5.0625V12.9375C16.3125 13.3851 16.1347 13.8143 15.8182 14.1307C15.5018 14.4472 15.0726 14.625 14.625 14.625H3.375C2.92745 14.625 2.49822 14.4472 2.18176 14.1307C1.86529 13.8143 1.6875 13.3851 1.6875 12.9375V5.0625M16.3125 5.0625C16.3125 4.61495 16.1347 4.18573 15.8182 3.86926C15.5018 3.55279 15.0726 3.375 14.625 3.375H3.375C2.92745 3.375 2.49822 3.55279 2.18176 3.86926C1.86529 4.18573 1.6875 4.61495 1.6875 5.0625M16.3125 5.0625V5.24475C16.3125 5.53286 16.2388 5.81618 16.0983 6.06772C15.9578 6.31926 15.7553 6.53065 15.51 6.68175L9.885 10.143C9.61891 10.3069 9.31252 10.3937 9 10.3937C8.68748 10.3937 8.38109 10.3069 8.115 10.143L2.49 6.6825C2.24469 6.5314 2.04215 6.32001 1.90168 6.06847C1.7612 5.81693 1.68747 5.53361 1.6875 5.2455V5.0625"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Email address"
                          value={Email}
                          maxLength={40}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </fieldset>
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="email">Mobile.</label>
                      <div className="ip-field">


                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.273 12.2348L13.293 10.2548C12.588 9.54977 11.43 9.54977 10.725 10.2548L9.9435 11.0363C9.87398 11.1059 9.78303 11.1502 9.68537 11.1622C9.58771 11.1742 9.48879 11.1531 9.40425 11.1023C8.27438 10.4296 7.39059 9.5459 6.71775 8.41602C6.66695 8.33148 6.64583 8.23256 6.65784 8.1349C6.66984 8.03724 6.71429 7.9462 6.7845 7.87677L7.566 7.09527C8.271 6.39027 8.271 5.23277 7.566 4.52777L5.586 2.54777C4.881 1.84277 3.723 1.84277 3.018 2.54777L1.917 3.64877C1.3905 4.17527 1.1685 4.93052 1.3215 5.66027C2.16823 9.6806 5.31517 12.8275 9.3355 13.6743C10.0652 13.8273 10.8205 13.6053 11.347 13.0788L12.448 11.9778C13.153 11.2728 14.3105 11.2728 15.0155 11.9778L15.273 12.2348Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Mobile number"
                          value={Mobile}
                          maxLength={10}
                          onChange={(e) => setMobile(e.target.value)}
                          onKeyDown={handleKeyPress}
                        />
                      </div>
                    </fieldset>
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="pass">Password</label>
                      <div className="ip-field">
                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.375 7.875V5.0625C12.375 4.16739 12.0194 3.30895 11.3865 2.67601C10.7535 2.04308 9.89511 1.6875 9 1.6875C8.10489 1.6875 7.24645 2.04308 6.61351 2.67601C5.98058 3.30895 5.625 4.16739 5.625 5.0625V7.875M5.0625 16.3125H12.9375C13.3851 16.3125 13.8143 16.1347 14.1307 15.8182C14.4472 15.5018 14.625 15.0726 14.625 14.625V9.5625C14.625 9.11495 14.4472 8.68573 14.1307 8.36926C13.8143 8.05279 13.3851 7.875 12.9375 7.875H5.0625C4.61495 7.875 4.18573 8.05279 3.86926 8.36926C3.55279 8.68573 3.375 9.11495 3.375 9.5625V14.625C3.375 15.0726 3.55279 15.5018 3.86926 15.8182C4.18573 16.1347 4.61495 16.3125 5.0625 16.3125Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Your password"
                          value={Password}
                          maxLength={25}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </fieldset>
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="confirm">Confirm password</label>
                      <div className="ip-field">
                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.375 7.875V5.0625C12.375 4.16739 12.0194 3.30895 11.3865 2.67601C10.7535 2.04308 9.89511 1.6875 9 1.6875C8.10489 1.6875 7.24645 2.04308 6.61351 2.67601C5.98058 3.30895 5.625 4.16739 5.625 5.0625V7.875M5.0625 16.3125H12.9375C13.3851 16.3125 13.8143 16.1347 14.1307 15.8182C14.4472 15.5018 14.625 15.0726 14.625 14.625V9.5625C14.625 9.11495 14.4472 8.68573 14.1307 8.36926C13.8143 8.05279 13.3851 7.875 12.9375 7.875H5.0625C4.61495 7.875 4.18573 8.05279 3.86926 8.36926C3.55279 8.68573 3.375 9.11495 3.375 9.5625V14.625C3.375 15.0726 3.55279 15.5018 3.86926 15.8182C4.18573 16.1347 4.61495 16.3125 5.0625 16.3125Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Confirm password"
                          value={confirmPassword}
                          maxLength={25}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </div>
                    </fieldset>
                  </div>
                  <div className="box box-btn">
                    <Link onClick={() => sendOTP()} className="tf-btn primary w-100">
                      Sign Up
                    </Link>
                    <div className="text text-center">
                      Don’t you have an account?
                      <a
                        href="#modalLogin"
                        data-bs-toggle="modal"
                        className="text-primary"
                      >
                        Sign In
                      </a>
                    </div>
                  </div>
                </>

                )
              }
              {
                otpflag && (<>
                  <div className="box">
                    <fieldset className="box-fieldset" style={{ marginBottom: '15px' }}>
                      <label htmlFor="name">Verify OTP</label>
                      <div className="ip-field">
                        <svg
                          className="icon"
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.4869 14.0435C12.9628 13.3497 12.2848 12.787 11.5063 12.3998C10.7277 12.0126 9.86989 11.8115 9.00038 11.8123C8.13086 11.8115 7.27304 12.0126 6.49449 12.3998C5.71594 12.787 5.03793 13.3497 4.51388 14.0435M13.4869 14.0435C14.5095 13.1339 15.2307 11.9349 15.5563 10.6056C15.8818 9.27625 15.7956 7.87934 15.309 6.60014C14.8224 5.32093 13.9584 4.21986 12.8317 3.44295C11.7049 2.66604 10.3686 2.25 9 2.25C7.63137 2.25 6.29508 2.66604 5.16833 3.44295C4.04158 4.21986 3.17762 5.32093 2.69103 6.60014C2.20443 7.87934 2.11819 9.27625 2.44374 10.6056C2.76929 11.9349 3.49125 13.1339 4.51388 14.0435M13.4869 14.0435C12.2524 15.1447 10.6546 15.7521 9.00038 15.7498C7.3459 15.7523 5.74855 15.1448 4.51388 14.0435M11.2504 7.31228C11.2504 7.90902 11.0133 8.48131 10.5914 8.90327C10.1694 9.32523 9.59711 9.56228 9.00038 9.56228C8.40364 9.56228 7.83134 9.32523 7.40939 8.90327C6.98743 8.48131 6.75038 7.90902 6.75038 7.31228C6.75038 6.71554 6.98743 6.14325 7.40939 5.72129C7.83134 5.29933 8.40364 5.06228 9.00038 5.06228C9.59711 5.06228 10.1694 5.29933 10.5914 5.72129C11.0133 6.14325 11.2504 6.71554 11.2504 7.31228Z"
                            stroke="#A3ABB0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          value={OTP}
                          maxLength={4}
                          onChange={(e) => setOTP(e.target.value)}
                        />
                      </div>
                    </fieldset>

                  </div>
                  <div className="box box-btn">
                    <Link onClick={() => handleRegister()} className="tf-btn primary w-100">
                      Sign Up
                    </Link>
                    <div className="text text-center">
                      Don’t you have an account?
                      <a
                        href="#modalLogin"
                        data-bs-toggle="modal"
                        className="text-primary"
                      >
                        Sign In
                      </a>
                    </div>
                  </div>
                </>

                )
              }

              {/* <p className="box text-center caption-2">or login with</p>
              <div className="group-btn">
                <a href="#" className="btn-social">
                  <img
                    alt="img"
                    src="/images/logo/google.jpg"
                    width={37}
                    height={36}
                  />
                  Google
                </a>
                <a href="#" className="btn-social">
                  <img
                    alt="img"
                    src="/images/logo/fb.jpg"
                    width={31}
                    height={30}
                  />
                  Facebook
                </a>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
